/**
 * Created by idea on 20/03/2017.
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { ApiService } from './Api.service';
import { ApiIcheckService } from './ApiIcheck.service';
import { User } from '../models/User';
// import { GoogleLoginProvider } from '../providers/googleLoginProvider';
import { IAuthenticate } from '../contracts/Authenticate.contract';
import { UserToken } from '../models/UserToken';
import { ApiEvsService } from './ApiEvs.service';
import { Router } from '@angular/router';

declare const PromiseWindow: any;

@Injectable()
export class AuthenticateService {
  public user: User;
  public icheck_token: string;
  private facebook: IAuthenticate;

  // private google: IAuthenticate;

  constructor(
    private http: ApiService,
    private httpIcheck: ApiIcheckService,
    private router: Router,
    private apiEvs: ApiEvsService
  ) {
    // this.facebook = new FacebookLoginProvider(environment.facebook, {scope: 'email, public_profile'});
    // this.google = new GoogleLoginProvider(environment.google);
  }

  public load() {
  }

  login(body: any) {
    console.log('body', body)
    let url = `/login`;
    // let login: Observable<Response>;
    let login;
    if (body.redirect_login) {
      login = this.apiEvs.post('/redirect-login', body);
    } else {
      if (body.provider) {
        login = this.loginSocial(body.provider);
      } else {
        if (body.rememberMe === true) {
          // body.ttl_in_second = 31556926;
          body.ttl_in_second = 999999999999999999999999999;
        }
        login = this.apiEvs.login(url, body);
      }
    }

    setTimeout(() => {
      if (!login) {
        // tslint:disable-next-line:no-unused-expression
        this.router.navigate['/'];
        console.log('reload');
      }
    }, 500);
    console.log('api authen', login)
    return login.map((res: any) => {
      console.log('ssss', res.data);
      const data = res.data;
      if (data.info.request_change_password == 0) {
        // localStorage.setItem('data', JSON.stringify(data) );
        // remove
        localStorage.removeItem('Access-Token');
        localStorage.removeItem('Access-Token-Icheck');
        localStorage.removeItem('User');
        localStorage.removeItem('FireBase-Token');
        if (localStorage.getItem('Access-Token-Reset')) {
          localStorage.removeItem('Access-Token-Reset');
        }
        // save
        localStorage.setItem('Access-Token', data.token);
        localStorage.setItem('FireBase-Token', data.firebase_token);
        if (body.provider === 'facebook') {
          localStorage.setItem('Access-Token-Icheck', this.icheck_token);
        } else {
          localStorage.setItem('Access-Token-Icheck', data.token_icheck);
        }
        localStorage.setItem('Token-Expire', data.ttl);
        const expiresAt = JSON.stringify(data.ttl * 1000 + Date.now());
        localStorage.setItem('expires_at', expiresAt);
        localStorage.setItem('lang', localStorage.getItem('lang') || 'vi');

        if (data.info && data.user_id) {
          data.info.user_id_evs = data.user_id;
          localStorage.setItem('User', JSON.stringify(data.info));
        }
        const user: any = {};
        // if (data.info) {
        //     user = data.info.social_name;
        //     user.name = data.info.social_name;
        // }
        // localStorage.setItem('auth_information', JSON.stringify({
        //     token: data.token,
        //     user: user,
        //     icheck_token: data.token_icheck
        // }));

        // if (!data.info.company || data.info.company.verified !== true) {
        //   this.router.navigate(['/evs/business/profile']);
        // }
      } else {
        localStorage.removeItem('Access-Token-Reset');
        localStorage.setItem('Access-Token-Reset', data.token);
      }
      return data;
    });
  }

  loginSocial(type: string) {
    const url = `/auth/` + type;
    const login = new Observable((observer) => {
      return this[type].login().then((data: UserToken) => {
        return this.http
          .get(url, { code: data.access_token })
          .toPromise()
          .then((data) => {
            this.icheck_token = data.icheck_token;
            return this.apiEvs
              .loginFB(this.icheck_token)
              .toPromise()
              .then((data) => observer.next(data));
          });
      });
    });
    return login;
  }

  // loginSocial(type: string) {
  //     console.log('loginSocial:', type);
  //     let url = `/auth/` + type;
  //     let login = new Observable(observer => {
  //         return this[type].login().then((data: UserToken) => {
  //             return this.http.get(url, {code: data.access_token}).toPromise().then(data => observer.next(data));
  //         });
  //     });
  //     return login;
  // }

  register(body: any) {
    // let url = 'http://sandbox.icheck.com.vn:5266/register';
    const url = '/account/register/qrcheck';
    return this.apiEvs.post_qr_core_aps(url, body);
  }

  logout() {
    const lang = localStorage.getItem('lang');
    localStorage.clear();
    if (lang) {
      localStorage.setItem('lang', lang);
    }
    sessionStorage.removeItem('seen');
  }

  linkAccount(token?: any, body?: any) {
    const url = '/qr_aps/user/link/v2?token=' + token
    return this.apiEvs.linkAccount(url, body);
  }

  registerIcheckAccout(body?: any) {
    const url = '/api/noauth/user/register/request'
    return this.apiEvs.registerIcheck(url, body);
  }

  confirmOTP(body?: any) {
    const url = '/api/noauth/user/register/confirm'
    return this.apiEvs.confirmOTPIcheck(url, body);
  }

  resendOTP(param?: any) {
    const url = '/api/noauth/user/register/resent-otp'
    return this.apiEvs.getResendOTP(url, param);
  }

}



// WEBPACK FOOTER //
// /app/src/app/common/services/Authenticate.service.ts